import { render } from "./breadDetails.vue?vue&type=template&id=7362cac5&scoped=true"
import script from "./breadDetails.vue?vue&type=script&lang=js"
export * from "./breadDetails.vue?vue&type=script&lang=js"

import "./breadDetails.vue?vue&type=style&index=0&id=7362cac5&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7362cac5"]])

export default __exports__